import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AssessmentProvider, useAssessment } from './contexts/AssessmentContext';
import { DemoProvider } from './contexts/DemoContext';
import { DesktopGate } from './components/DesktopGate';
import { TopBar } from './components/TopBar';
import { Footer } from './components/Footer';
import { Consent } from './pages/Consent';
import { Briefing } from './pages/Briefing';
import { Workspace } from './pages/Workspace';
import { Submitted } from './pages/Submitted';
import { Admin } from './pages/Admin';
import { Intake } from './pages/demo/Intake';
import { RoleAnalysis } from './pages/demo/RoleAnalysis';
import { Configure } from './pages/demo/Configure';
import { Pipeline } from './pages/demo/Pipeline';
import { InstrumentPreview } from './pages/demo/InstrumentPreview';
import { Invite } from './pages/demo/Invite';
import { DecisionRecord } from './pages/demo/DecisionRecord';
function RequireConsent({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    consented
  } = useAssessment();
  const location = useLocation();
  if (!consented) return <Navigate to="/consent" replace state={{
    from: location.pathname
  }} data-id="element-0" data-mp="3mk852v2dm5by" />;
  return <>{children}</>;
}

// The candidate-facing portal keeps its own chrome; the buyer demo screens carry theirs.
function CandidateShell({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex min-h-full w-full flex-col bg-slate-100" data-id="element-1" data-mp="2zllijblcf2rh">
      <TopBar data-id="element-2" data-mp="2znfyebhrc4op" />
      {children}
      <Footer data-id="element-3" data-mp="33lwyib2rgewm" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-4" data-mp="38lromcepp0gm">
      <AssessmentProvider data-id="element-5" data-mp="38l8iru2c62iy">
        <DemoProvider data-id="element-6" data-mp="38l03xwmnkn54">
          <DesktopGate data-id="element-7" data-mp="38kgm0fx05yr3">
            <Routes data-id="element-8" data-mp="3dkuufz2inapn">
              <Route path="/" element={<Navigate to="/demo" replace data-id="element-10" data-mp="3dlntedv8gvx8" />} data-id="element-9" data-mp="3dle30p6a0mr0" />

              <Route path="/demo" element={<Intake data-id="element-12" data-mp="nwc2huqftzxb" />} data-id="element-11" data-mp="nvj4pj9gikrb" />
              <Route path="/demo/analysis" element={<RoleAnalysis data-id="element-14" data-mp="nxwupdpa56s0" />} data-id="element-13" data-mp="nuraabrlit2m" />
              <Route path="/demo/configure" element={<Configure data-id="element-16" data-mp="sssq8ntq6c9v" />} data-id="element-15" data-mp="stuexv3nyxa2" />
              <Route path="/demo/pipeline" element={<Pipeline data-id="element-18" data-mp="35gkl05ue1ig" />} data-id="element-17" data-mp="36hx792iaw2a" />
              <Route path="/demo/instrument" element={<InstrumentPreview data-id="element-20" data-mp="3ud1glcmeruc7" />} data-id="element-19" data-mp="34nb3rfi0xwm" />
              <Route path="/demo/invite" element={<Invite data-id="element-22" data-mp="3uevui6z9im6s" />} data-id="element-21" data-mp="3ubzsa6gdtbcj" />
              <Route path="/demo/record" element={<DecisionRecord data-id="element-24" data-mp="d3cvbquvaug1" />} data-id="element-23" data-mp="d4e5lt427cwp" />

              <Route path="/consent" element={<CandidateShell data-id="element-26" data-mp="86cm572q1bkp">
                    <Consent data-id="element-27" data-mp="3gl4t5lvoq8m5" />
                  </CandidateShell>} data-id="element-25" data-mp="d2biphy7dzw7" />
              <Route path="/briefing" element={<CandidateShell data-id="element-29" data-mp="3bkgqg2y3g3c3">
                    <RequireConsent data-id="element-30" data-mp="3qbpkqpcxycvk">
                      <Briefing data-id="element-31" data-mp="3qcr37ewae1nb" />
                    </RequireConsent>
                  </CandidateShell>} data-id="element-28" data-mp="3bmbalf1jjrf4" />
              <Route path="/workspace" element={<CandidateShell data-id="element-33" data-mp="2xssj0cysi31g">
                    <RequireConsent data-id="element-34" data-mp="2swbtpffutims">
                      <Workspace data-id="element-35" data-mp="2svafx37gei1d" />
                    </RequireConsent>
                  </CandidateShell>} data-id="element-32" data-mp="2xuwsrbjddw9n" />
              <Route path="/submitted" element={<CandidateShell data-id="element-37" data-mp="1d6ko4jt1qnpw">
                    <RequireConsent data-id="element-38" data-mp="yg3lwy8l7try">
                      <Submitted data-id="element-39" data-mp="yh6ct65wtw7v" />
                    </RequireConsent>
                  </CandidateShell>} data-id="element-36" data-mp="1d4hmt3mg185v" />
              <Route path="/admin" element={<CandidateShell data-id="element-41" data-mp="1r2698fw5snd1">
                    <Admin data-id="element-42" data-mp="1w33skvswnng4" />
                  </CandidateShell>} data-id="element-40" data-mp="1r498zrn45uuy" />

              <Route path="*" element={<Navigate to="/demo" replace data-id="element-44" data-mp="1i4ch7h5fgfvo" />} data-id="element-43" data-mp="1i3uk6iaxxxmp" />
            </Routes>
          </DesktopGate>
        </DemoProvider>
      </AssessmentProvider>
    </BrowserRouter>;
}